import {GridColumn, GridColumnGroupDef} from "@data/interefaces/data.interfaces";
import {TableColumnsUtil} from "@data/util/table-columns-util";
import {FeatureComponentMode} from "@core/enums/core.enums";

export class ProductSponsorVerbatimComponentUtil extends TableColumnsUtil {

  protected static override setColumn(column: GridColumn, featureComponentMode: FeatureComponentMode) {
    switch (column.field) {
      case 'select':
      case 'actions':
        column.hide = (featureComponentMode !== FeatureComponentMode.DEFAULT);
        break;
      case 'processing_status':
        column.hide = true;
        break;
      case 'processing_note':
        column.hide = (featureComponentMode === FeatureComponentMode.DEFAULT);
        column.downloadable = (featureComponentMode !== FeatureComponentMode.DEFAULT);
        break;
      default:
        // leave as is
        break;
    }
  }

}
